import React from "react"

import createStandardGermanDate from "scripts/createStandardGermanDate"
import createStandardGermanDateWithTime from "scripts/createStandardGermanDateWithTime"
import { Link } from "gatsby"
import doenerCase from "scripts/doenerCase"
import { CalendarIcon } from "components/page-components/Icons/small"

export const BfzEventHitCard = ({ event }) => {
  const {
    event_whole_day,
    event_start_date,
    event_end_date,
    event_is_ad,
    image,
    title,
  } = event

  const start = event_whole_day
    ? createStandardGermanDate(event_start_date * 1000)
    : createStandardGermanDateWithTime(event_start_date * 1000)
  const end = event_whole_day
    ? createStandardGermanDate(event_end_date * 1000)
    : createStandardGermanDateWithTime(event_end_date * 1000)

  return (
    <React.Fragment>
      <Link
        to={`/fachzeitschriften/umweltbau/termine/${doenerCase(title)}`}
        className="box is-shadowless is-bordered is-clickable is-relative is-flex is-flex-direction-column"
        id={doenerCase(title)}
        style={{ minHeight: 320 }}
      >
        <div className="mb-5" style={{ height: 80 }}>
          {!!image ? (
            <img
              src={image}
              title={title}
              alt={title}
              style={{ maxWidth: 200, maxHeigh: 80 }}
            />
          ) : (
            <div
              style={{
                border: "3px solid #034055",
                borderRadius: "50%",
                width: 71,
                height: 71,
                display: "flex",
              }}
            >
              <div className="m-auto">
                <CalendarIcon {...{ size: 1.3 }} />
              </div>
            </div>
          )}
        </div>

        <p className="title has-text-evergabe is-8">
          {start}
          {!!event_end_date ? " - " + end : null}
        </p>

        <p className="has-text-mitternachtsblau has-text-weight-bold">
          {title}
        </p>

        <p className="link is-semi-shy mt-auto has-text-mitternachtsblau">
          Beschreibung öffnen
        </p>
        {event_is_ad && (
          <div
            style={{
              position: "absolute",
              right: 15,
              top: 15,
            }}
            className={`tag is-mitternachtsblau-10 has-text-title-slim`}
          >
            Anzeige
          </div>
        )}
      </Link>
    </React.Fragment>
  )
}
